module.exports = __webpack_public_path__ + "img/i6.47a95792.jpg";